import React from 'react';
import styled from 'styled-components';
import { Popover, PopoverProps } from 'antd';

export const HoverButton = styled.button`
    border: none;
    box-shadow: none;
    background-color: transparent;
    border-radius: 20px;
    transition: transform 0.15s ease-out;
    width: 30px;
    height: 30px;
    padding: 0;

    &:hover {
        cursor: pointer;
        background-color: rgba(117, 153, 255, 0.3);
    }
`;

interface Props {
    popoverProps: PopoverProps;
}

export const InfoPopover: React.FC<Props> = ({ children, popoverProps = { placement: 'leftTop' } }) => {
    return (
        <Popover title='Information' trigger='click' {...popoverProps} content={children}>
            <HoverButton style={{ width: children === undefined ? 0 : 30 }}>
                <span style={{ display: 'flex', justifyContent: 'center' }}>
                    <svg width='24' height='24' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
                        <path
                            fillRule='evenodd'
                            clipRule='evenodd'
                            d='M3 12C3 16.9706 7.02944 21 12 21C16.9706 21 21 16.9706 21 12C21 7.02944 16.9706 3 12 3C7.02944 3 3 7.02944 3 12ZM19.8 12C19.8 16.3078 16.3078 19.8 12 19.8C7.6922 19.8 4.20002 16.3078 4.20002 12C4.20002 7.6922 7.6922 4.20002 12 4.20002C16.3078 4.20002 19.8 7.6922 19.8 12Z'
                            fill='#8B8B8B'
                        />
                        <path
                            opacity='0.3'
                            fillRule='evenodd'
                            clipRule='evenodd'
                            d='M12 21C12 21 21 16.9706 21 12C21 7.02944 12 3 12 3C12 3 16.8 7.02944 16.8 12C16.8 16.9706 12 21 12 21Z'
                            fill='#8B8B8B'
                        />
                        <rect x='10.5' y='9.75' width='3' height='8.25' rx='1.5' fill='#8B8B8B' />
                        <path
                            fillRule='evenodd'
                            clipRule='evenodd'
                            d='M12 9C12.8284 9 13.5 8.32843 13.5 7.5C13.5 6.67157 12.8284 6 12 6C11.1716 6 10.5 6.67157 10.5 7.5C10.5 8.32843 11.1716 9 12 9Z'
                            fill='#8B8B8B'
                        />
                    </svg>
                </span>
            </HoverButton>
        </Popover>
    );
};
